<div style="font-size: 12px;">
    <div class="panel-body">
      <div class="row">
        <div class="col-sm">
          <label class="lable-title">COMPANY NAME</label>
          <p class="paragraph-text">{{ details?.out_company_name }}</p>
        </div>
        <div class="col-sm">
          <label class="lable-title">FIRST AND LAST NAME</label>
          <p class="paragraph-text">{{ details?.out_first_name }} {{
            details?.out_last_name }}</p>
        </div>
        <!-- <div class="col-sm">
          <label class="lable-title">STATUS</label>
          <p class="paragraph-text">{{ details?.out_status_desc }}</p>
        </div> -->
      </div>
      <div class="row">
        <!-- <div class="col-sm">
          <label class="lable-title">PART ID / CONTRACT</label>
          <p class="paragraph-text">{{ details?.out_tenant_id }}</p>
        </div> -->
        <div class="col-sm">
          <label class="lable-title">PHONE</label>
          <p class="paragraph-text">{{ details?.out_phone }}</p>
        </div>
        <div class="col-sm">
          <label class="lable-title">EMAIL</label>
          <p class="paragraph-text">{{ details?.out_email }}</p>
        </div>
        <!-- <div class="col-sm">
          <label class="lable-title">NEXT BILLING DATE</label>
          <p class="paragraph-text">{{ details?.out_next_billing_date }}</p>
        </div> -->
      </div>
      <div class="row">

        <div class="col-sm">
          <label class="lable-title">ADDRESS</label>
          <p class="paragraph-text" class="paragraph-text">{{ details?.out_address_1 }} {{
            details?.out_address_2 }} {{ details?.out_address_3 }} {{
            details?.out_city}}, {{ details?.out_region }} {{
            details?.out_post_code
            }}
          </p>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-sm-4">
          <button class="button button-red button-mid edit-enduser"
            (click)="editEndUserDetail($event)">Edit End User</button>
        </div>
      </div> -->
    </div>
  </div>